var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedBadg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1583_8840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13.1249C9.79609 13.1249 9.59375 13.1155 9.39414 13.0979C8.36419 13.0059 7.36824 12.6829 6.48034 12.1529C5.59244 11.6229 4.83544 10.8995 4.26562 10.0366L0.78125 16.2499H5.27344L7.53906 19.9999L10.7629 13.0823C10.5096 13.1105 10.2549 13.1247 10 13.1249ZM15.7422 10.0288C14.917 11.2785 13.7082 12.2264 12.2977 12.7296L10.6914 16.2304L12.4609 19.9999L14.7266 16.2499H19.2188L15.7422 10.0288Z",
    fill: "#dc0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.001 8.125C11.0365 8.125 11.876 7.28553 11.876 6.25C11.876 5.21447 11.0365 4.375 10.001 4.375C8.96544 4.375 8.12598 5.21447 8.12598 6.25C8.12598 7.28553 8.96544 8.125 10.001 8.125Z",
    fill: "#dc0a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0.625C6.89844 0.625 4.375 3.14844 4.375 6.25C4.375 9.35156 6.89844 11.875 10 11.875C13.1016 11.875 15.625 9.35156 15.625 6.25C15.625 3.14844 13.1016 0.625 10 0.625ZM10 9.375C9.38193 9.375 8.77775 9.19172 8.26384 8.84834C7.74994 8.50496 7.3494 8.0169 7.11288 7.44589C6.87635 6.87487 6.81447 6.24653 6.93505 5.64034C7.05562 5.03415 7.35325 4.47733 7.79029 4.04029C8.22733 3.60325 8.78415 3.30562 9.39034 3.18505C9.99653 3.06447 10.6249 3.12635 11.1959 3.36288C11.7669 3.5994 12.255 3.99994 12.5983 4.51384C12.9417 5.02775 13.125 5.63193 13.125 6.25C13.1241 7.07852 12.7945 7.87283 12.2087 8.45868C11.6228 9.04453 10.8285 9.37407 10 9.375Z",
    fill: "#dc0a0a"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1583_8840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBadg);
export default __webpack_public_path__ + "static/media/red-badg.6db3078581f6e591ec5492b6dcb2527d.svg";
export { ForwardRef as ReactComponent };